<template>
  <div @click="onClick" class="stats no-hover">
    <div class="stats-number highlighted">{{ count }}</div>
    <div class="stats-label">
      <span class="stats-small-label"> {{ smallLabel }} </span>
      <span class="stats-normal-label"> {{ label }} </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'counter-card',
  props: {
    label: String,
    smallLabel: String,
    count: Number,
    identifier: String,
  },
  emits: ['clicked'],
  methods: {
    onClick: function (): void {
      this.$emit('clicked', {
        count: this.count,
        label: this.label,
        smallLabel: this.smallLabel,
        identifier: this.identifier,
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.counter-card {
  width: 200px;
  height: 75px;
  background: #bdc8d4;
  border-left: 0.25rem solid #4e73df;
  border-radius: 0.35rem;
  font-family: Nunito, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
}

.card-title {
  color: #4e73df;
}

.stats-number {
  font-size: 28px;
  color: #098dcd;
  font-weight: 400;
  width: calc(100% - 180px);
}

.stats-label {
  width: 150px;
  padding-left: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  line-height: 1.15;
  color: #627588;
  font-size: 14px;
}

.highlighted {
  position: relative;
  min-width: 40px;
  text-align: center;
  padding: 0 15px;
}

.highlighted:before {
  content: '';
  display: block;
  right: auto;
  left: 50%;
  bottom: auto;
  top: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  height: 50px;
  width: 100%;
  min-width: 50px;
  border-radius: 65px;
  z-index: 0;
  background: rgba(9, 141, 205, 0.1);
}

.stats {
  padding: 10px 12px;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: center;
  cursor: pointer;
  width: 300px;
}

.stats-small-label {
  font-size: 12px;
  font-weight: 300;
  width: 100%;
}

.stats-normal-label {
  text-transform: capitalize;
  font-size: 18px;
  font-weight: 600;
  width: 100%;
}
</style>
